import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MapPin, Wifi } from 'lucide-react';
import { Button } from './Button';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: index * 0.1,
      ease: [0.22, 1, 0.36, 1] as const
    }
  })
};
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-ink pt-20 text-white" data-id="element-91">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-brand/20 blur-3xl" aria-hidden="true" data-id="element-92" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-brand/10 blur-3xl" aria-hidden="true" data-id="element-93" />

      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:py-28 lg:px-8" data-id="element-94">
        <div data-id="element-95">
          <motion.div variants={fadeUp} initial="hidden" animate="show" custom={0} data-id="element-96">
            <span className="inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-4 py-1.5 text-sm font-medium text-brand" data-id="element-97">
              <MapPin className="h-4 w-4" aria-hidden="true" data-id="element-98" />
              Vancouver, Washington
            </span>
          </motion.div>

          <motion.h1 variants={fadeUp} initial="hidden" animate="show" custom={1} className="mt-6 font-heading text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl" data-id="element-99">
            Your local <span className="text-brand" data-id="element-100">fiber internet</span> dealer
          </motion.h1>

          <motion.p variants={fadeUp} initial="hidden" animate="show" custom={2} className="mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-101">
            AllStar Home Solutions helps Vancouver-area households explore fiber
            internet options with clear, personal guidance. Start with an
            address availability check and find a plan that fits your home.
          </motion.p>

          <motion.div variants={fadeUp} initial="hidden" animate="show" custom={3} className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-102">
            <Button asChild size="lg" className="h-12 bg-brand px-7 text-base text-brand-foreground hover:bg-brand-dark" data-id="element-103">
              <a href="#contact" data-id="element-104">
                Check Your Address{' '}
                <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-105" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-12 border-white/25 bg-transparent px-7 text-base text-white hover:bg-white/10 hover:text-white" data-id="element-106">
              <a href="#services" data-id="element-107">Explore Fiber Options</a>
            </Button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-108">
          <div className="rounded-3xl border border-white/10 bg-white/5 p-7 shadow-2xl sm:p-10" data-id="element-109">
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-brand text-brand-foreground" data-id="element-110">
              <Wifi className="h-8 w-8" aria-hidden="true" data-id="element-111" />
            </span>
            <p className="mt-8 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-112">
              Fiber made simpler
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-tight sm:text-3xl" data-id="element-113">
              Start with your address.
            </h2>
            <p className="mt-4 leading-relaxed text-white/65" data-id="element-114">
              Tell us where you live and what you need from your connection.
              We’ll help you understand the fiber options available for your
              home.
            </p>
            <div className="mt-8 border-t border-white/10 pt-5 text-sm text-white/60" data-id="element-115">
              Local guidance for Vancouver, WA households
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}